import * as React from 'react';
import classNames from 'classnames';
import { observer } from 'src/utils/mobx-react';
import { SelectionViewModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionViewModel';
import { SelectionItemStyle } from 'src/domains/sportsbook/webview/components/Selection/Selection.style';
import { useAppStateContext } from 'src/appState/AppState';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { EventRowSelectionLine, EventRowSelectionWithLine } from '../sportEventsListNew/EventRowMobx.style';
import { LockIcon } from 'src/ui/assets/icons/other/LockIcon';
import { useCommon } from 'src/domains/common/Common';
import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';

interface PropsType {
    className?: string;
    selectionId: SelectionId | undefined;
    sp: boolean | undefined;
    onHoverSelection?: () => void;
    borderTop?: boolean;
    borderRight?: boolean;
    borderBottom?: boolean;
    borderLeft?: boolean;
    lineLabel?: string | null;
    isExpandedLayout?: boolean;
    forceSuspended?: boolean;
}

export const SelectionNewVersion = observer('SelectionNewVersion', (props: PropsType) => {
    const common = useCommon();
    const { betSlipState } = AppSportsBookState.get(common);
    const { selectionId, sp, lineLabel = null, isExpandedLayout = false, forceSuspended = false } = props;

    const selectionView = (): SelectionViewModel | null => {
        if (selectionId !== undefined) {
            const selectionModel = selectionId.getModel();

            if (selectionModel !== null) {
                return selectionModel.forView(sp);
            }
        }

        return null;
    };

    const choose = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();

        if (forceSuspended) {
            return;
        }

        if (selectionId !== undefined && sp !== undefined) {
            if (sp) {
                betSlipState.legsState.betslipData.onAddSPBet(selectionId);
            } else {
                betSlipState.legsState.betslipData.onAddSimpleBet(selectionId);
            }
        }
    };

    const onIsSelected = (): boolean => {
        if (selectionId !== undefined) {
            return betSlipState.isSelected(selectionId);
        }

        return false;
    };

    const { className: classNameFromProps, onHoverSelection, borderTop, borderRight, borderBottom, borderLeft } = props;

    const modelForView = selectionView();

    // TODO: [Genius] To remove this check and leave only componentVariants.selectionVariant when GLOB-37 is fully live
    const {
        unifiedComponentConfig: {
            componentVariants: { selectionVariant },
            unifiedSportEventsTable,
        },
    } = useAppStateContext();

    if (modelForView === null) {
        return (
            <SelectionItemStyle
                borderBottom={borderBottom}
                borderLeft={borderLeft}
                borderRight={borderRight}
                borderTop={borderTop}
                className='selection'
                href='#'
                onClick={choose}
                variant={selectionVariant}
                isExpandedLayout={isExpandedLayout}
                isEmpty
            >
                -
            </SelectionItemStyle>
        );
    }

    const { priceChange, suspended, price, displayPrice } = modelForView;
    const isSuspended = suspended || forceSuspended;

    const isEmpty = price === undefined;

    const selectedNew = onIsSelected();

    const className = classNames([classNameFromProps, 'selection']);

    const selectionIdDataTest: string | number | undefined =
        price === 'sp' ? `sp-${props.selectionId?.toOldId() ?? 'id-undefined'}` : props.selectionId?.toOldId();

    const renderSelectionContent = () => {
        if (isSuspended) {
            return unifiedSportEventsTable ? <LockIcon className='selection-suspended--icon' /> : null;
        }

        return lineLabel !== null ? (
            <EventRowSelectionWithLine>
                <EventRowSelectionLine>{lineLabel}</EventRowSelectionLine>
                <div>{displayPrice}</div>
            </EventRowSelectionWithLine>
        ) : (
            displayPrice
        );
    };

    return (
        <SelectionItemStyle
            data-test={isSuspended ? 'selection-suspended' : 'selection'}
            data-test-selection-id={selectionIdDataTest}
            borderBottom={borderBottom}
            borderLeft={borderLeft}
            borderRight={borderRight}
            borderTop={borderTop}
            className={className}
            href='#'
            isOddsDown={priceChange === 'down'}
            isOddsUp={priceChange === 'up'}
            isSelected={selectedNew}
            isSuspended={isSuspended}
            isEmpty={isEmpty}
            onClick={choose}
            onMouseOver={onHoverSelection}
            variant={selectionVariant}
            isExpandedLayout={isExpandedLayout}
        >
            {renderSelectionContent()}
        </SelectionItemStyle>
    );
});
